"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WishlistServiceReadyEvent = void 0;
const event_type_1 = require("../enums/event-type");
class WishlistServiceReadyEvent {
    constructor(wishlistService) {
        this.wishlistService = wishlistService;
        this.eventType = WishlistServiceReadyEvent.EventType;
        this.timestamp = new Date();
    }
}
exports.WishlistServiceReadyEvent = WishlistServiceReadyEvent;
WishlistServiceReadyEvent.EventType = event_type_1.WishlistServiceEventType.WISHLIST_SERVICE_READY;
